"use client";

import { cn } from "@/lib/utils";
import { useCustomEditor } from "@/providers/custom-editor-provider";
import { useEffect } from "react";

const EditorTypeOptions = ({
	isEditMode,
	defaultEditorType,
	onEditorTypeChange,
}: {
	isEditMode?: boolean;
	defaultEditorType: "discussion" | "article";
	onEditorTypeChange: (type: "discussion" | "article") => void;
}) => {
	const { editorType, setEditorType, getHtml } = useCustomEditor();

	useEffect(() => {
		setEditorType(defaultEditorType);
	}, [defaultEditorType]);

	const handleEditorTypeChange = (type: "discussion" | "article") => {
		if (type === editorType) return;

		const hasContent = !(getHtml()?.trim() === "<p></p>" || getHtml() === undefined);
		if (hasContent && window && window.confirm) {
			const userConfirmed = window.confirm(
				"Warning: Changing the editor type will clear the current content. Do you want to proceed?"
			);
			if (!userConfirmed) return;
		}

		setEditorType(type);
		onEditorTypeChange(type);
	};

	return (
		<div className="mb-5 flex items-center justify-start gap-5">
			<button
				type="button"
				disabled={isEditMode}
				onClick={() => handleEditorTypeChange("discussion")}
				className={cn(
					"border-b-2 border-b-transparent pb-1 font-semibold text-gray-800 disabled:cursor-not-allowed disabled:opacity-50",
					editorType === "discussion" && "border-b-gray-300 text-brand-primary"
				)}
			>
				Discussion
			</button>

			<button
				type="button"
				disabled={isEditMode}
				onClick={() => handleEditorTypeChange("article")}
				className={cn(
					"border-b-2 border-b-transparent pb-1 font-semibold text-gray-800 disabled:cursor-not-allowed disabled:opacity-50",
					editorType === "article" && "border-b-gray-300 text-brand-primary"
				)}
			>
				Article
			</button>
		</div>
	);
};

export default EditorTypeOptions;
